export const LOCAL_STORAGE_APP_USER_ITEM_KEY = "app-user";
export const APP_NAME = "insights";
